// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"feee5e12","239":"2f822dd7","396":"d8bc5292","455":"f32529e2","946":"9e7251da"}[chunkId] + ".chunk.js";
};